import { createUpsell } from '../upsell';
export const oEX9H0 = createUpsell({
    id: 'oEX9H0',
    desc: 'Upsell sequence for RH coach & supplements with conditional logic - US',
    seq: [
        {
            id: 'upsell-coach',
            onPurchase: [
                {
                    upsellPhysical: ['upsell-supplements'],
                },
                'upsell-digital-products-bundle',
            ],
            onDecline: [
                {
                    upsellPhysical: ['upsell-supplements'],
                },
                'upsell-12-month-pilates-us',
                'upsell-yoga-healthy-back',
                'upsell-digital-products-bundle',
            ],
        },
    ],
});
